module.exports = __webpack_public_path__ + "static/media/lenovox1carbon.539cfe72.jpg";